"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoModule = void 0;
class GoModule {
    constructor(name, version) {
        this.packages = [];
        this.name = name;
        this.version = version;
    }
    // fullName returns the module's name and version, separated with an `@`. This
    // reflects how Go stores them on disk (except for vendored paths).
    fullName() {
        return this.name + "@" + this.version;
    }
}
exports.GoModule = GoModule;
//# sourceMappingURL=go-module.js.map